import { useSSRData } from 'hooks';
import { isNewUser } from 'utils';
import getFirstCorrectData from './utils';

const useNewUser = () => {
    const state = useSSRData();
    // eslint-disable-next-line camelcase
    return getFirstCorrectData(state?.new_user, isNewUser(), false);
};

export default useNewUser;
